import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "../scss/typography.scss";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        background: "#f2f2f2",
        blue: "#0770a4",
        green: "#00C12A",
        primary: "#0485b1",
        navbar: "#000",
      },
      dark: {
        background: "#2a2a2a",
        blue: "#00d2ff",
        green: "#00C12A",
        primary: "#00d2ff",
        navbar: "#1e1e1e",
      },
    },
  },
});
